import store from "@/store";
import axios from "axios";

const request = {
  headers(imp = true, bearer = true) {
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Cache-control": "no-cache",
    };

    if (
      bearer &&
      store.getters["auth/session"] &&
      store.getters["auth/session"].access_token
    ) {
      let token = store.getters["auth/session"].access_token;
      headers["Authorization"] = "Bearer " + token;
    }

    if (
      imp &&
      store.getters["auth/impUser"] &&
      store.getters["auth/impUser"].id
    ) {
      headers["x-impersonate-uid"] = store.getters["auth/impUser"].id;
    }

    return headers;
  },
  get(url, params, imp = true, bearer = true) {
    let reqHeaders = this.headers(imp, bearer);
    return axios({
      method: "GET",
      url: `${process.env.VUE_APP_API}${url}`,
      params: params,
      headers: reqHeaders,
      // onDownloadProgress: function(progressEvent) {
      //   let percentCompleted = Math.round(
      //     (progressEvent.loaded * 100) / progressEvent.total
      //   );
      //   Vue.prototype.$eventBus.$emit(
      //     Vue.prototype.$const.FileUploadProgress,
      //     percentCompleted
      //   );
      // }
    });
  },
  post(url, data, params, imp = true) {
    return axios({
      method: "POST",
      url: `${process.env.VUE_APP_API}${url}`,
      params: params,
      data: data,
      headers: this.headers(imp),
      // onUploadProgress: function(progressEvent) {
      //   let percentCompleted = Math.round(
      //     (progressEvent.loaded * 100) / progressEvent.total
      //   );
      //   Vue.prototype.$eventBus.$emit(
      //     Vue.prototype.$const.FileUploadProgress,
      //     percentCompleted
      //   );
      // }
    });
  },
  postFile(url, formData, params, imp = true) {
    let headers = this.headers(imp);
    headers["Content-Type"] = "application/x-www-form-urlencoded";

    return axios({
      method: "POST",
      url: `${process.env.VUE_APP_API}${url}`,
      params: params,
      data: formData,
      headers: headers,
    });
  },
  put(url, data, params) {
    return axios({
      method: "PUT",
      url: `${process.env.VUE_APP_API}${url}`,
      params: params,
      data: data,
      headers: this.headers(),
      // onUploadProgress: function(progressEvent) {
      //   let percentCompleted = Math.round(
      //     (progressEvent.loaded * 100) / progressEvent.total
      //   );
      //   Vue.prototype.$eventBus.$emit(
      //     Vue.prototype.$const.FileUploadProgress,
      //     percentCompleted
      //   );
      // }
    });
  },
  patch(url, data, params, imp = true) {
    return axios({
      method: "PATCH",
      url: `${process.env.VUE_APP_API}${url}`,
      params: params,
      data: data,
      headers: this.headers(imp),
      // onUploadProgress: function(progressEvent) {
      //   let percentCompleted = Math.round(
      //     (progressEvent.loaded * 100) / progressEvent.total
      //   );
      //   Vue.prototype.$eventBus.$emit(
      //     Vue.prototype.$const.FileUploadProgress,
      //     percentCompleted
      //   );
      // }
    });
  },
  delete(url, params, data) {
    return axios({
      method: "DELETE",
      url: `${process.env.VUE_APP_API}${url}`,
      params: params,
      data: data,
      headers: this.headers(),
    });
  },
  getRemoteBlob(url, params, headers = {}) {
    return axios({
      method: "GET",
      url: url,
      params: params,
      headers: headers,
      responseType: "blob",
      // onDownloadProgress: function(progressEvent) {
      //   let percentCompleted = Math.round(
      //     (progressEvent.loaded * 100) / progressEvent.total
      //   );
      //   Vue.prototype.$eventBus.$emit(
      //     Vue.prototype.$const.FileUploadProgress,
      //     percentCompleted
      //   );
      // }
    });
  },
};

export default request;
